import { render, staticRenderFns } from "./viewFrame.vue?vue&type=template&id=08d03fe7"
import script from "./viewFrame.vue?vue&type=script&lang=js"
export * from "./viewFrame.vue?vue&type=script&lang=js"
import style0 from "./viewFrame.vue?vue&type=style&index=0&id=08d03fe7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports